<template>
    <div>
        <div class="text-center mb-4">
            <h3>Verify Your Email Address</h3>
            <p class="mb-0">A verification code has been sent to your email address.</p>
            <p>Please check your inbox (including spam folder) and enter the code below to continue</p>
        </div>
         <ValidationObserver v-slot="{ passes }">
        <form id="frmSecond" @submit.prevent="passes(onSubmit)">
            <div class="d-flex align-items-center justify-content-center mb-5">
                 <validation-provider rules="required" v-slot="{ errors }">
                    <input id="email" style="width:300px;text-align:center;" v-model="verify_1" name="verify_1" autocomplete="off" autofocus type="text" @keyup="getVerificationCode2($event)" :class="'form-control verify_1 '+ (errors[0]?'error-input':'')"  />
                    <small class="error-message">  * {{ errors[0] }} </small>
                </validation-provider>
                <!-- <input type="text" style="width:300px" name="verify_1" v-model="verify_1" @keyup="getVerificationCode2($event)" class="form-control verify_1" > -->
                <!-- <input type="text" name="verify_2" @keyup="getVerificationCode($event)" class="form-control verify_2" maxlength="1">
                <input type="text" name="verify_3" @keyup="getVerificationCode($event)" class="form-control verify_3" maxlength="1">
                <input type="text" name="verify_4" @keyup="getVerificationCode($event)" class="form-control verify_4" maxlength="1">
                <input type="text" name="verify_5" @keyup="getVerificationCode($event)" class="form-control verify_5" maxlength="1">
                <input type="text" name="verify_6" @keyup="getVerificationCode($event)" class="form-control verify_6" maxlength="1"> -->
            </div>
            <!-- <input name="regi_id" value="8" type="hidden" /> -->


            <div class="generic-error">
                <!-- <span class="require">*</span> Something went wrong! -->
            </div>

            <div class="d-flex align-items-center justify-content-between">
                <button type="button" @click.prevent="goPrev()" class="btn btn-outline-muted">BACK</button>
                <button type="submit" :disabled="buttonLoader" class="btn btn-action" :style="$parent.is_third_party_enrollment == 4 ? 'min-width: 125px;' : 'min-width: 80px;'">
                    <span v-if="buttonLoader" class="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true"/>
                    <span v-else>NEXT</span>
                </button>
            </div>
        </form>
         </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Marked fields are required'
});
export default {
    name: 'StepTwo',
    mixins: [nccregistrarMixin],
    components: {
       ValidationProvider,
       ValidationObserver
    },
    data() {
        return {
            verify_1:'',
            buttonLoader: false
        }
    },
    created() {
        setTimeout(() => {
            document.querySelector('.generic-error').innerHTML='';
        }, 500);
    },
    mounted() {
        vueEvent.$on('buttonLoader', (value) => {
            this.buttonLoader = value;
        });
    },
    methods: {
       goPrev(){
           this.$parent.backStepOne();
       },
       onSubmit(){
           this.buttonLoader = true;
           this.$parent.clickStepTwoForward();
       },
       getVerificationCode2(e){
            document.querySelector('.generic-error').innerHTML='';
            if(this.verify_1==6){
                document.querySelector('.generic-error').innerHTML='';
            }else{
                //document.querySelector('.generic-error').innerHTML='<span class="require">*</span> Invalid verification code.';
            }
       },
       getVerificationCode(e){
           if(e.keyCode == 91){
                // get text FROM the clipboard
                navigator.clipboard.readText()
                .then((text) => {
                    if(text.length==6){
                        document.querySelector('.verify_1').value=text[0];
                        document.querySelector('.verify_2').value=text[1];
                        document.querySelector('.verify_3').value=text[2];
                        document.querySelector('.verify_4').value=text[3];
                        document.querySelector('.verify_5').value=text[4];
                        document.querySelector('.verify_6').value=text[5];

                        document.querySelector('.generic-error').innerHTML='';
                    }else{
                        document.querySelector('.generic-error').innerHTML='<span class="require">*</span> Invalid verification code.';
                    }
                })
           }
       }
    }
}
</script>
